import { FICHA_EMAIL_CC, FICHA_EMAIL_CORPO_PREFIXO } from "./financeiro-ficha-viewer.constants";

export interface FichaMailtoParams {
  codigo: string;
  embarcacao: string;
  /** Nome do usuário logado, que assina a mensagem. */
  usuario: string;
}

/** Título da ficha usado no assunto, no corpo e no arquivo: `Ficha Financeira da Obra_ID-<código>_<embarcação>`. */
export function buildFichaTitulo(codigo: string, embarcacao: string): string {
  return `${FICHA_EMAIL_CORPO_PREFIXO}_ID-${codigo}_${embarcacao}`;
}

/**
 * Composição do e-mail à controladoria: sem "Para", com os "Cc" fixos, assunto e corpo prontos. Os
 * endereços são codificados um a um e unidos por vírgula literal; quebras de linha viram CRLF.
 */
export function buildFichaMailto({ codigo, embarcacao, usuario }: FichaMailtoParams): string {
  const titulo = buildFichaTitulo(codigo, embarcacao);
  const corpo = [
    "Olá, tudo bem?",
    "",
    `Segue, em anexo, a ${titulo}.`,
    "",
    "Obrigado,",
    "",
    usuario,
  ].join("\r\n");
  const cc = FICHA_EMAIL_CC.map(encodeURIComponent).join(",");

  return `mailto:?cc=${cc}&subject=${encodeURIComponent(titulo)}&body=${encodeURIComponent(corpo)}`;
}

/** Abre o cliente de e-mail padrão sem sair da página. */
export function openMailto(url: string): void {
  const link = document.createElement("a");

  link.href = url;
  link.click();
}
